import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var int = function int(v) {
  return parseFloat(v);
};

var countRows = function countRows(h, l) {
  return Math.round(h / l);
};

var binarySearch = function binarySearch(text, cb) {
  var min = 0,
      max = text.length - 1;

  while (min <= max) {
    var mid = parseInt((max + min) / 2);
    var result = cb(mid);
    max = result > 0 ? mid - 1 : max;
    min = result < 0 ? mid + 1 : min;
    if (result === 0) return mid;
  }
};

export var MultiClamp = /*#__PURE__*/function () {
  function MultiClamp(element) {
    var _this = this;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : params || {};

    _classCallCheck(this, MultiClamp);

    _defineProperty(this, "initStyle", function () {
      var offsetHeight = _this.ele.offsetHeight;
      var paddingTop = int(_this.getStyle('paddingTop'));
      var paddingBottom = int(_this.getStyle('paddingBottom'));
      var lineHeight = int(_this.getStyle('lineHeight'));

      if (isNaN(lineHeight)) {
        _this.ele.innerText = 'test';
        lineHeight = _this.ele.offsetHeight - paddingTop - paddingBottom;
        _this.ele.innerText = _this.text;
      }

      return {
        height: offsetHeight - paddingTop - paddingBottom,
        lineHeight: lineHeight
      };
    });

    _defineProperty(this, "createExpandableDom", function () {
      var expandDom = document.createElement('span');
      expandDom.innerHTML = _this.expandLabel;
      expandDom.className = 'jmtd-typography-link jmtd-expand-label';

      expandDom.onclick = function () {
        _this.onChange && _this.onChange(true);
      };

      return expandDom;
    });

    _defineProperty(this, "createCloseableDom", function () {
      var closeDom = document.createElement('span');
      closeDom.innerHTML = _this.closeLabel;
      closeDom.className = 'jmtd-typography-link jmtd-close-label';

      closeDom.onclick = function () {
        _this.onChange && _this.onChange(false);
      };

      return closeDom;
    });

    _defineProperty(this, "sliceText", function (pos) {
      return "".concat(_this.text.slice(0, pos)).concat(_this.symbol);
    });

    _defineProperty(this, "fillText", function (text, addExp) {
      _this.ele.innerHTML = text;
      if (addExp) _this.ele.appendChild(_this.expandableDom);
    });

    _defineProperty(this, "getStyle", function (attr) {
      return window.getComputedStyle ? window.getComputedStyle(_this.ele, null)[attr] : _this.ele.currentStyle[attr];
    });

    _defineProperty(this, "contentRow", function (pos) {
      _this.ele.innerHTML = _this.sliceText(pos);

      if (_this.expandable) {
        _this.ele.appendChild(_this.expandableDom);
      }

      return countRows(_this.ele.offsetHeight, _this.lineHeight);
    });

    // 设置默认配置，并将用户配置添加到this
    Object.assign(this, {
      rows: 2,
      expandable: false,
      closable: false,
      expanded: false,
      symbol: '...',
      expandLabel: '展开',
      closeLabel: '收起'
    }, config); // 展开状态，需判断是否需要收起按钮

    if (this.expanded) {
      if (this.closable) {
        element.appendChild(this.createCloseableDom());
      }

      return;
    }

    this.ele = element;
    this.text = element.innerText;
    var eleStyle = this.initStyle();
    this.lineHeight = eleStyle.lineHeight; // 判断文本行数是否需要显示省略号，不需要直接返回

    var height = eleStyle.height,
        _lineHeight = eleStyle.lineHeight;
    if (countRows(height, _lineHeight) <= this.rows) return; // 如需要展开功能，创建对应标签

    if (this.expandable) this.expandableDom = this.createExpandableDom(); // 文本溢出隐藏

    this.clamp();
  } // 容器初始属性值


  _createClass(MultiClamp, [{
    key: "clamp",
    value: // 文本溢出隐藏
    function clamp() {
      var _this2 = this;

      var text = this.text,
          rows = this.rows,
          expandable = this.expandable,
          fillText = this.fillText;
      var pos = binarySearch(text, function (cur) {
        var curRows = _this2.contentRow(cur);

        if (curRows !== rows) return curRows - rows;
        return _this2.contentRow(cur + 1) - rows - 1;
      });
      fillText(this.sliceText(pos), expandable);
    }
  }]);

  return MultiClamp;
}();